import { API_PREFIX, type CreateMakeoverRequest, type CreateMakeoverResponse } from '@paint-ai/shared';
import { apiRequest } from '@/lib/api-client';

export const makeoversApi = {
  create: (request: CreateMakeoverRequest) =>
    apiRequest<CreateMakeoverResponse>(`${API_PREFIX}/makeovers`, { method: 'POST', body: request }),
};
